"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as t } from "react";
import e from "../components/Icon/SvgIcon.js";
const r = (o) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22 9.892q0 .265-.313.577l-4.363 4.254 1.033 6.01q.012.083.012.24a.7.7 0 0 1-.126.427.43.43 0 0 1-.366.174 1 1 0 0 1-.481-.144L12 18.594l-5.397 2.837a1 1 0 0 1-.48.144q-.253 0-.379-.174a.7.7 0 0 1-.126-.427q0-.073.024-.24l1.033-6.01-4.374-4.255Q2 10.144 2 9.892q0-.444.673-.553l6.034-.877 2.704-5.469q.228-.492.589-.493.36 0 .589.493l2.704 5.468 6.034.878q.673.108.673.553",
        clipRule: "evenodd"
      }
    )
  }
), a = t(r);
export {
  a as Star,
  a as default
};
